module.exports = __webpack_public_path__ + "img/OS.129a50c4.jpg";